///<reference path="../../../Dtos/Isilog.IsiComponent.IsiDataTransferObject.ts" />

import { IIsiDtoIwsAssociatedViewClientState, IsiDtoIwsAssociatedViewClientState } from "./../../../Dtos/Isilog.IsiComponent.IsiDataTransferObject";
import { IsiIwsAssociatedView } from "./../../../IsiWebGUI/Components/Grid/IsiIwsAssociatedView.component";
import { IsiAssociatedViewContext } from "../../../IsiWebGUI/IsiFW/Components/Grid/AssociatedView/IsiAssociatedViewContext";
import { IIsiIwsGridViewContext } from "../IIsiIwsGridViewContext";
import { IIsiComponentManager } from "../../../IsiWebGUI/IsiFW/Core/Manager/IIsiComponentManager";
import { IsiDtoSelectedFieldValue, IsiDtoSelectedRecord, IsiDtoSelectedRecordSet } from "../../../Dtos/Isilog.IsiComponent.IsiDataTransferObject.IsiPlMark";

/**
 * Contexte d'une DA 
 **/
export class IsiIWSAssociatedViewContext extends IsiAssociatedViewContext<IsiIwsAssociatedView> implements IIsiIwsGridViewContext {

    _associatedViewState: IIsiDtoIwsAssociatedViewClientState;

    /**retourne le nombre de lignes une fois évalué*/
    _nbPages?: number = null;
    _nbRecord?: number = null;

    //Retourne la colonne de la derniere cellule cliquée
    _lastColumnClicked?: string = "";
    //Retourne le niveau d'une sous grille
    _gridLevel?: string = "";

    constructor(componentManager: IIsiComponentManager, componentId: string, state: IsiDtoIwsAssociatedViewClientState) {
        super(componentManager, componentId, state);
        this._associatedViewState = state;
    }

    get nbPages() {
        return this._nbPages;
    }
    set nbPages(value:number) {
        this._nbPages = value;
    }
    get nbRecord() {
        return this._nbRecord;
    }
    set nbRecord(value: number) {
        this._nbRecord = value;
    }

    get lastColumnClicked() {
        return this._lastColumnClicked;
    }
    set lastColumnClicked(value: string) {
        this._lastColumnClicked = value;
    }

    get gridLevel() {
        return this._gridLevel;
    }
    set gridLevel(value: string) {
        this._gridLevel = value;
    }
    //constructor(associatedViewState: IIsiDtoAssociatedViewClientState) {
    //    super(associatedViewState);
    //    this._associatedViewState = associatedViewState;
    //}

    get associatedViewState() {
        return this._associatedViewState;
    }

    get name() {
        return this.associatedViewState.name
    }
    get scriptNameForTs() {
        return this.associatedViewState.scriptNameForTs
    }
    get module() {
        return this.associatedViewState.module
    }

    get id() {
        return this.associatedViewState.contextId;
    }

    get showCounter(): boolean {
        return this.associatedViewState.showCounter;
    }

    /**
   * Donne les valeurs des colonnes de clés pour chaque ligne sélectionnée 
   * */
    getSelectedRowsRealKeysValues(): IsiDtoSelectedRecordSet {
        let srv = IsiDtoSelectedRecordSet.fromJS({     
            records: [],
            isAllSelected: false
        });

        this.selectedRows.rows.forEach((row) => {

            let record = IsiDtoSelectedRecord.fromJS({
                fields: []
            });

            for (var key in row.realKey) {
                let field = IsiDtoSelectedFieldValue.fromJS({
                    key: key,
                    value: row.realKey[key]
                });
                record.fields.push(field);
            }
            srv.records.push(record);
        });

        return srv;
    }

    /**
  * Donne les valeurs des colonnes de clés pour chaque ligne sélectionnée 
  * */
    getSelectedRowsFieldsValues(fields: Array<string>): IsiDtoSelectedRecordSet {
        let srv = IsiDtoSelectedRecordSet.fromJS({  
            records: [],
            isAllSelected: false
        });

        this.selectedRows.rows.forEach((row) => {

            let record = IsiDtoSelectedRecord.fromJS({
                fields: []
            });

            for (const element of fields) {
                let field = IsiDtoSelectedFieldValue.fromJS({
                    key: element,
                    value: row.datas[element]
                });
                record.fields.push(field);
            }
            srv.records.push(record);
        });

        return srv;
    }

}
